import Vue from "vue";
let currentRequest = 0;

const ApplicationLogService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("application_logs", id, {
        include: "user"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START APPLICATION_LOG `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "application_logs",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] APPLICATION_LOG DISCARDED`);
        return null;
      }
      console.log(`[${request}] END APPLICATION_LOG `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("application_logs", payload);
      } else {
        return await Vue.$jsonApi.update("application_logs", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("application_logs", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { ApplicationLogService };
